// initial state
const state = {
    appVersion: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {};

export const app = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
